import Rate from './Rate';
import e_carter from '../img/comments/e_carter.svg'
import j_melad from '../img/comments/j_melad.svg'
import s_lin from '../img/comments/s_lin.svg'
import d_brooks from '../img/comments/d_brooks.svg'
import left_btn from '../img/comments/left-arrow.svg'
import right_btn from '../img/comments/right-arrow.svg'
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// import required modules
import { Navigation } from 'swiper/modules';

export default function Comments() {
  
  const comments = [
    { 
        id: 1, 
        text: "BuildTheTech completely changed our approach to Web3 development! Their smart contract optimization boosted our project's performance and cut costs dramatically. The team is highly professional and always ahead of industry trends — truly a game-changer for us.", 
        author: 'Evelyn Carter', 
        author_avatar: e_carter, 
        author_bio: 'PRODUCT LEAD, BLOCKMINT, SAN FRANCISCO' 
    },
    { 
        id: 2, 
        text: "We partnered with BuildTheTech to build our NFT marketplace, and the results were beyond expectations. Their attention to detail, from tokenomics to seamless UX, made the launch smooth and successful. Highly recommend them for any blockchain venture.", 
        author: 'Jahan Melad', 
        author_avatar: j_melad, 
        author_bio: 'FOUNDER, CHAINVERSE, BERLIN' 
    },
    { 
        id: 3, 
        text: "Thanks to BuildTheTech, we integrated decentralized identity solutions into our platform effortlessly. Their Web3 expertise is unmatched, and the team makes even the most complex concepts simple and practical. Outstanding collaboration experience!", 
        author: 'Sophia Lin', 
        author_avatar: s_lin, 
        author_bio: 'HEAD OF INNOVATION, METANOVA, SINGAPORE' 
    },
    { 
        id: 4, 
        text: "BuildTheTech helped us migrate to a scalable Layer 2 infrastructure, which boosted transaction speeds and reduced fees significantly. Their strategic insights and fast delivery exceeded all expectations.", 
        author: 'Daniel Brooks', 
        author_avatar: d_brooks, 
        author_bio: 'CTO, CRYPTEX, NEW YORK' 
    }
  ];
  
  return (
    <section className="comments container">
      <header className='comments-head'>
        <h2>What Our Clients Say</h2>
        <aside>
          <Rate />
          <nav>
            <button className='comment-arrow comment-arrow-left'>
                <img src={left_btn} alt='arrow-right' />
            </button>
            <button className='comment-arrow comment-arrow-right'>
                <img src={right_btn} alt='arrow-right' />
            </button>
          </nav>
        </aside>
      </header>
      <section className='comment-swiper'><Swiper 
        slidesPerView={1.3}
        spaceBetween={20}
        breakpoints={{
          500: {
            slidesPerView: 1.8,
            spaceBetween: 30
          },
          700: {
            slidesPerView: 2.3,
            spaceBetween: 30
          },
          900: {
            slidesPerView: 2.8,
            spaceBetween: 40
          },
          1200: {
            slidesPerView: 3.3,
            spaceBetween: 40
          }
        }}
        navigation={{
          nextEl: '.comment-arrow-right',
          prevEl: '.comment-arrow-left'
        }}
        modules={[Navigation]}
        className="comment-list"
      >
        {comments.map((comment) => (
          <SwiperSlide>
            <article className='comment'>
              <blockquote className='comment-text'>
                <p>{comment.text}</p>
              </blockquote>
              <footer>
                <img src={comment.author_avatar} alt={comment.author} />
                <div className='comment-author'>
                  <p>{comment.author}</p>
                  <span>{comment.author_bio}</span>
                </div>
              </footer>
            </article>
          </SwiperSlide>
        ))}
        <SwiperSlide></SwiperSlide>
      </Swiper>
      </section>
    </section>
  )
}
